<template>
  <div
    class="card card-ticket bg-blurry mb-3"
    :class="{'disabled' : disabled }"
  >
    <NuxtLink
        class="inherit"
        :title="seoTitle"
        :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: isDutch ? promoReward.origin.city.slug_nl : promoReward.origin.city.slug_en, iata: promoReward.origin.iata.toLowerCase(), toname: isDutch ? promoReward.destination.city.slug_nl : promoReward.destination.city.slug_en, toiata: promoReward.destination.iata.toLowerCase() } }">
      <div class="card-header d-flex align-items-center">
        <p class="mb-0 fw-bold small opacity-75 me-auto">{{ promoReward.airline === 'KL' ? 'KLM' : 'Air France' }}</p>
        <NuxtImg v-if="promoReward.airline === 'KL'"
            alt="KLM Logo"
            class="me-2 position-relative"
            height="12"
            width="20"
            style="top: -2px"
            src="img/klm-logo.svg"
            loading="lazy"
        />
        <NuxtImg v-else
                 alt="KLM Logo"
                 class="me-2 position-relative"
                 height="12"
                 width="20"
                 style="top: -2px"
                 src="img/af-logo.svg"
                 loading="lazy"
        />
      </div>
    <div class="card-body d-flex align-items-center">
      <div class="w-25 text-start">
        <p class="mb-1 small truncate text-uppercase opacity-75">
          {{ isDutch ? promoReward.origin.city.name_nl : promoReward.origin.city.name }}
        </p>
        <div class="d-flex align-items-center">
          <NuxtImg
              :src="promoReward.origin.city.country.flag"
              :alt="promoReward.origin.city.country.name + ' flag emoji'"
              height="20"
              width="26"
              loading="lazy"
          />
          <p class="mb-0 ms-2 h2">
            {{ promoReward.origin.iata }}
          </p>
        </div>
      </div>
      <div class="w-50 mx-auto">
        <div class="route position-relative d-flex align-items-center">
          <hr>
          <NuxtImg
              src="img/plane.svg"
              alt="Plane icon"
              width="20"
              height="17"
              loading="lazy"
          />
          <p class="mb-0 small fw-bold mx-auto">{{ formattedTime }}</p>
        </div>
      </div>
      <div class="w-25 text-end">
        <p class="mb-1 small truncate text-uppercase opacity-75">
          {{ isDutch ? promoReward.destination.city.name_nl : promoReward.destination.city.name }}
        </p>
        <div class="d-flex align-items-center justify-content-end">
          <p class="mb-0 me-2 h2 text-white">
            {{ promoReward.destination.iata }}
          </p>
          <NuxtImg
              :src="promoReward.destination.city.country.flag"
              :alt="promoReward.destination.city.country.name + ' flag emoji'"
              height="20"
              width="26"
              loading="lazy"
          />
        </div>
      </div>
    </div>
    <div class="card-footer d-flex align-items-end">
      <div class="w-25">
        <p class="mb-0 small text-uppercase text-white opacity-75">
          {{ isDutch ? "Korting" : "Discount" }}
        </p>
        <p class="mb-0 fw-bold text-white">{{ promoReward.discount }}%</p>
      </div>
      <div class="mx-auto">
        <p class="mb-0 small text-uppercase text-white opacity-75">
          {{ isDutch ? "Reisklasse" : "Cabin" }}
        </p>
        <p class="mb-0 fw-bold text-white"> {{ formatCabin }}</p>
      </div>
      <div class="w-sm-25 text-end">
        <span role="button" class="btn btn-primary btn-sm fw-bold text-white">{{ Intl.NumberFormat().format(promoReward.miles) }} miles</span>
      </div>
    </div>
    </NuxtLink>
  </div>
</template>

<script setup>

import moment from "moment";

const props = defineProps({
  promoReward: Object,
  disabled: Boolean,
});

const { promoReward, disabled } = toRefs(props);

const isDutch = inject('isDutch');

const formatCabin = computed(() => {
  if (props.promoReward.cabin === 'Premium Economy') {
    return 'Premium'
  }
  return props.promoReward.cabin
})

const seoTitle = computed(() => {
  let airline = props.promoReward.airline === 'KL' ? 'KLM' : 'Air France';
  if (isDutch) {
    return airline + ' vluchten vanaf ' + props.promoReward.origin.city.name_nl + ' (' + props.promoReward.origin.iata + ') naar ' + props.promoReward.destination.city.name_nl + ' (' + props.promoReward.destination.iata + ')';
  } else {
    return airline + ' flights from ' + props.promoReward.origin.city.name + ' (' + props.promoReward.origin.iata + ') to ' + props.promoReward.destination.city.name + ' (' + props.promoReward.destination.iata + ')';
  }
});

const formattedTime = computed(() => {
  if(!props.promoReward.route || !props.promoReward.route.time){
    return ''
  }

  let duration = moment.duration(props.promoReward.route.time, 'minutes');
  return `${Math.floor(duration.asHours())}h ${duration.minutes()}m`;
});


</script>
